export enum TicketStatus {
  New = 'New',
  Update = 'Update',
  Resolved = 'Resolved',
  Closed = 'Closed',
}
